import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d9ac4bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Concluir Lançamento", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_5 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_13 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"5px","margin-bottom":"5px"}
}, null, -1))
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_25 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_26 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "vezes", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, null, -1))
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-4 ant-col-xl-4" }, null, -1))
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_selecionar_marcador_titulo_financeiro = _resolveComponent("selecionar-marcador-titulo-financeiro")!
  const _component_card = _resolveComponent("card")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_sazonalidade = _resolveComponent("selecionar-sazonalidade")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1200,
    centered: ""
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", null, "Adicionar Título no Contas a " + _toDisplayString(_ctx.obtemDescricaoTipo()), 1)
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmar()))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Documento",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_documento_financeiro, {
                            codigoSelecionado: _ctx.state.titulo.codigoTipoDocumentoFinanceiro,
                            "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.titulo.codigoTipoDocumentoFinanceiro) = $event)),
                            empresas: _ctx.telaBase.empresasSelecionadas,
                            descricaoSelecionado: _ctx.state.titulo.descricaoTipoDocumentoFinanceiro,
                            "onUpdate:descricaoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.titulo.descricaoTipoDocumentoFinanceiro) = $event)),
                            contasPagar: (_ctx.props.tipoTituloFinanceiro === _ctx.ETipoTituloFinanceiro.Pagar),
                            contasReceber: (_ctx.props.tipoTituloFinanceiro === _ctx.ETipoTituloFinanceiro.Receber)
                          }, null, 8, ["codigoSelecionado", "empresas", "descricaoSelecionado", "contasPagar", "contasReceber"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _withDirectives(_createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_a_form_item, {
                            label: "Número do Título",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.titulo.numeroTitulo) = $event)),
                                disabled: _ctx.verificaAlteracaoNumeroTitulo()
                              }, null, 8, _hoisted_8), [
                                [_vModelText, _ctx.state.titulo.numeroTitulo]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_a_form_item, {
                            label: "Parcela",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "ant-input ss-input-numerico",
                                min: "0",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.titulo.parcela) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.titulo.parcela]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ], 512), [
                        [_vShow, (_ctx.state.repetir)]
                      ]),
                      _withDirectives(_createVNode(_component_a_form_item, {
                        label: "Número do Título",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.titulo.numeroTitulo) = $event)),
                            disabled: _ctx.verificaAlteracaoNumeroTitulo()
                          }, null, 8, _hoisted_10), [
                            [_vModelText, _ctx.state.titulo.numeroTitulo]
                          ])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, (!_ctx.state.repetir)]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_a_form_item, {
                        label: "Vencimento",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            dataSelecionada: _ctx.state.titulo.dataVencimento,
                            "onUpdate:dataSelecionada": [
                              _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.titulo.dataVencimento) = $event)),
                              _cache[7] || (_cache[7] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                            ]
                          }, null, 8, ["dataSelecionada"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_form_item, {
                        label: "Competência",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            dataSelecionada: _ctx.state.titulo.dataCompetencia,
                            "onUpdate:dataSelecionada": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.titulo.dataCompetencia) = $event))
                          }, null, 8, ["dataSelecionada"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_a_form_item, {
                        label: "Valor",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            monetario: true,
                            quantidadeCasasDecimais: 2,
                            valor: _ctx.state.titulo.valorTotal,
                            "onUpdate:valor": [
                              _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.titulo.valorTotal) = $event)),
                              _cache[10] || (_cache[10] = ($event: any) => (_ctx.atualizarSaldo()))
                            ]
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_a_form_item, {
                        label: "Pessoa",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_pessoa, {
                            codigoSelecionado: _ctx.state.titulo.codigoPessoa,
                            "onUpdate:codigoSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.titulo.codigoPessoa) = $event)),
                            empresas: _ctx.telaBase.empresasSelecionadas,
                            recursoOrigem: _ctx.props.recursoOrigem
                          }, null, 8, ["codigoSelecionado", "empresas", "recursoOrigem"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_selecionar_conta, {
                        codigoSelecionado: _ctx.state.titulo.codigoConta,
                        "onUpdate:codigoSelecionado": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.titulo.codigoConta) = $event)),
                        empresas: _ctx.telaBase.empresasSelecionadas,
                        descricaoSelecionado: _ctx.state.titulo.descricaoConta,
                        "onUpdate:descricaoSelecionado": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.titulo.descricaoConta) = $event))
                      }, null, 8, ["codigoSelecionado", "empresas", "descricaoSelecionado"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_a_form_item, {
                        label: "Categoria",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_categoria_plano_conta, {
                            codigoSelecionado: _ctx.state.titulo.codigoPlanoContaCategoria,
                            "onUpdate:codigoSelecionado": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.titulo.codigoPlanoContaCategoria) = $event)),
                            empresas: _ctx.telaBase.empresasSelecionadas
                          }, null, 8, ["codigoSelecionado", "empresas"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_a_form_item, {
                        label: "Observações",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.titulo.observacoes) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.titulo.observacoes]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_a_form_item, {
                        label: "Marcadores",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_marcador_titulo_financeiro, {
                            marcadoresSelecionados: _ctx.state.marcadores,
                            "onUpdate:marcadoresSelecionados": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                            tipo: _ctx.state.titulo.tipo
                          }, null, 8, ["marcadoresSelecionados", "tipo"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.state.repetir,
                    "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.repetir) = $event)),
                    onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.checkRepetir()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Repetir")
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _withDirectives(_createElementVNode("div", null, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_a_form_item, {
                          label: "Período",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_sazonalidade, {
                              valor: _ctx.state.sazonalidade,
                              "onUpdate:valor": [
                                _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.sazonalidade) = $event)),
                                _cache[20] || (_cache[20] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                              ]
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      (_ctx.state.sazonalidade === _ctx.ESazonalidade.customizada)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_a_form_item, {
                                label: "Intervalo",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    min: "1",
                                    class: "ant-input ss-input-numerico",
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.sazonalidadeCustomizada) = $event)),
                                    onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                  }, null, 544), [
                                    [_vModelText, _ctx.state.sazonalidadeCustomizada]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_a_form_item, {
                                label: "Durante",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    min: "1",
                                    class: "ant-input ss-input-numerico",
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.repeticao) = $event)),
                                    onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                  }, null, 544), [
                                    [_vModelText, _ctx.state.repeticao]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_a_form_item, {
                                label: " ",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_28
                                ]),
                                _: 1
                              })
                            ]),
                            _hoisted_29
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_a_form_item, {
                                label: "Durante",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    min: "1",
                                    class: "ant-input ss-input-numerico",
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.repeticao) = $event)),
                                    onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.atualizarUltimoVencimento()))
                                  }, null, 544), [
                                    [_vModelText, _ctx.state.repeticao]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_a_form_item, {
                                label: " ",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.obterDescricaoSazonalidade()), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _hoisted_32
                          ], 64)),
                      _createElementVNode("div", _hoisted_33, [
                        (_ctx.UtilitarioGeral.valorValido(_ctx.state.titulo.dataVencimento) && _ctx.state.repeticao > 0)
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 0,
                              description: _ctx.obterMensagemRepeticao(),
                              style: {"white-space":"pre"},
                              type: "info",
                              "show-icon": ""
                            }, null, 8, ["description"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 512), [
                    [_vShow, (_ctx.state.repetir)]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["visible"]))
}